import $ from 'jquery'
import Backbone from 'backbone'

import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import i18n from 'scoreboard/components/i18n'

import template from './api-token-view.hbs'
import ApiTokenDialogView from './api-token-dialog-view'

/**
 * Displays a row for a single API token in ApiTokensView
 */
const ApiTokenView = Backbone.View.extend({
	tagName: 'tr',

	/**
	 * @type ApiToken
	 */
	model: null,

	events: {
		'click .action-show': 'onClickShow',
		'click .action-delete': 'onClickDelete'
	},

	render () {
		this.$el.empty().append(template(this.model.attributes))
		return this
	},

	onClickShow () {
		appDisplay.dialog(new ApiTokenDialogView({ model: this.model }))
	},

	onClickDelete () {
		let confirmation = new DeleteConfirmation({
			description: i18n.get('admin.apiToken')
		})

		appDisplay.dialog(confirmation)

		confirmation.once('confirm', () => {
			var url = 'api/admin/api-tokens/' + this.model.id
			$.delete(url, data => {
				this.trigger('delete')
				confirmation.trigger('done')
			})
		})
	}
})

export default ApiTokenView

ApiTokenView.__filename__ = 'admin/api-tokens/api-token-view.js'
